document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".promo-slider-wrapper");

  wrappers.forEach(wrapper => {
    const inner = wrapper.querySelector(".promo-slider-inner");
    let slides = Array.from(inner.children);

    // Ensure there is enough content to cover at least twice the container's width.
    let totalWidth = slides.reduce((sum, slide) => sum + slide.offsetWidth, 0);
    while (totalWidth < wrapper.offsetWidth * 2) {
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        inner.appendChild(clone);
      });
      slides = Array.from(inner.children);
      totalWidth = slides.reduce((sum, slide) => sum + slide.offsetWidth, 0);
    }

    // Position each slide based on cumulative width.
    let x = 0;
    slides.forEach(slide => {
      slide.style.position = "absolute";
      slide.style.left = `${x}px`;
      // Save the x position in a data attribute for easy access.
      slide.dataset.x = x;
      x += slide.offsetWidth;
    });

    const speed = 1; // Adjust this value for faster/slower scrolling.

    function scroll() {
      slides.forEach(slide => {
        let currentX = parseFloat(slide.dataset.x);
        currentX -= speed;
        slide.dataset.x = currentX;
        slide.style.left = `${currentX}px`;
      });

      // Check if the first slide has completely scrolled off-screen.
      let firstSlide = slides[0];
      if (parseFloat(firstSlide.dataset.x) + firstSlide.offsetWidth <= 0) {
        // Remove the first slide from the array.
        slides.shift();

        // Find the rightmost slide's position.
        let lastSlide = slides[slides.length - 1];
        let newX = parseFloat(lastSlide.dataset.x) + lastSlide.offsetWidth;

        // Reposition the off-screen slide to the end.
        firstSlide.dataset.x = newX;
        firstSlide.style.left = `${newX}px`;

        // Append it back to our slides array.
        slides.push(firstSlide);
      }

      requestAnimationFrame(scroll);
    }

    scroll(); // Start the animation loop.
  });
  let footer_headings = [...document.querySelectorAll(".footer-block__heading")];
  footer_headings.forEach(function (footer_heading) {
    footer_heading.addEventListener("click", function () {
      footer_heading.classList.toggle("active")
    })
  })
  document.addEventListener("click", function (event) {
    // Open/close toggle for the cart footer opener
    if (event.target.closest(".cart-drawer__footer .opener")) {
      document.querySelector(".cart-drawer-footer-x").classList.toggle("show");
    }

    // Close button inside cart details
    if (event.target.closest(".cart-detail__close")) {
      document.querySelector(".cart-drawer-footer-x").classList.remove("show");
    }
  });

  function accordion_init() {
    [...document.querySelectorAll(".accordion-c")].forEach(accordion => {
      let accordion_items = [...accordion.querySelectorAll(".accordion__item")];
      let first_item = accordion_items[0];
      let first_content = first_item.querySelector(".accordion__content");
  
      first_item.classList.add("active");
      gsap.set(first_content, { opacity: 1, height: "auto" });
  
      accordion_items.forEach(accordion_item => {
        let accordion_btn = accordion_item.querySelector("summary");
        let accordion_content = accordion_item.querySelector(".accordion__content");
  
        if (accordion_btn && accordion_content) {
          accordion_btn.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default behavior of summary elements.
  
            if (accordion_item.classList.contains("active")) {
              accordion_item.classList.remove("active");
              gsap.to(accordion_content, {
                duration: 0.3,
                opacity: 0,
                height: 0,
                onComplete: function () {}
              });
            } else {
              let activeItem = accordion.querySelector(".accordion__item.active");
              if (activeItem) {
                let activeContent = activeItem.querySelector(".accordion__content");
                activeItem.classList.remove("active");
                gsap.to(activeContent, {
                  duration: 0.3,
                  opacity: 0,
                  height: 0,
                  onComplete: function () {}
                });
              }
              gsap.to(accordion_content, {
                duration: 0.3,
                opacity: 1,
                height: "auto"
              });
              accordion_item.classList.add("active");
            }
          });
        }
      });
    });
  }
  function product_accordion_init() { [...document.querySelectorAll(".product__info-wrapper")].forEach(accordion => { let accordion_items = [...accordion.querySelectorAll(".accordion__item")]; accordion_items.forEach(accordion_item => { let accordion_btn = accordion_item.querySelector("summary"), accordion_content = accordion_item.querySelector(".accordion__content"); accordion_btn && accordion_content && accordion_btn.addEventListener("click", function () { if (accordion_item.classList.contains("active")) accordion_item.classList.remove("active"), gsap.to(accordion_content, { duration: .3, opacity: 0, height: 0, onComplete: function () { } }); else { let activeItem = accordion.querySelector(".accordion__item.active"); if (activeItem) { let activeContent = activeItem.querySelector(".accordion__content"); activeItem.classList.remove("active"), gsap.to(activeContent, { duration: .3, opacity: 0, height: 0, onComplete: function () { } }) } gsap.to(accordion_content, { duration: .3, opacity: 1, height: "auto" }), accordion_item.classList.add("active") } }) }) }) }
  product_accordion_init();
  accordion_init()
});
